/** Team login roles (Settings → Team access). Distinct from staff roster roles on Staff page. */

export const STAFF_LINKED_LOGIN_ROLES = ["stylist", "therapist"];

export function needsStaffProfile(role) {
    return STAFF_LINKED_LOGIN_ROLES.includes(role);
}

/** Roster `staff.role` that must match when linking a service-provider login. */
export function rosterRoleForLogin(loginRole) {
    if (loginRole === "stylist" || loginRole === "therapist") return loginRole;
    return null;
}
